module.exports = __webpack_public_path__ + "static/media/proj20_img15.bf629124.jpg";